
<div class="avatar">
  <div
    v-if="hasImage"
    class="image"
    :style="computedImageStyle"
  />

  <icon v-else name="person" />
</div>
